var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#6F42A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1052 31.0859C32.2525 31.0859 33.1826 30.1397 33.1826 28.9725L33.1826 18.4126C33.1826 17.2454 32.2525 16.2992 31.1052 16.2992L29.4491 16.2992L29.4491 12.5474C29.4491 11.3802 28.5184 10.4339 27.3705 10.4339L8.89429 10.4339C7.74633 10.4339 6.81572 11.3802 6.81572 12.5474L6.81572 24.2739C6.81572 25.4411 7.74633 26.3874 8.89429 26.3874L11.716 26.3874L11.716 28.9725C11.716 30.1397 12.646 31.0859 13.7934 31.0859L31.1052 31.0859ZM13.5625 26.3874L13.5625 28.9725C13.5625 29.1022 13.6659 29.2073 13.7934 29.2073L31.1052 29.2073C31.2327 29.2073 31.336 29.1022 31.336 28.9725L31.336 18.4126C31.336 18.283 31.2327 18.1778 31.1052 18.1778L29.4491 18.1778L29.4491 24.2739C29.4491 25.4411 28.5184 26.3874 27.3705 26.3874L13.5625 26.3874ZM27.6014 24.2739C27.6014 24.4036 27.498 24.5087 27.3705 24.5087L8.89429 24.5087C8.76674 24.5087 8.66334 24.4036 8.66334 24.2739L8.66334 12.5474C8.66334 12.4177 8.76674 12.3126 8.89429 12.3126L27.3705 12.3126C27.498 12.3126 27.6014 12.4177 27.6014 12.5474L27.6014 24.2739Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2503 14.9805C18.7013 14.9805 19.0669 15.1763 19.0669 15.418V21.543C19.0669 21.7846 18.7013 21.9805 18.2503 21.9805C17.7992 21.9805 17.4336 21.7846 17.4336 21.543V15.418C17.4336 15.1763 17.7992 14.9805 18.2503 14.9805Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 18.4807C14.75 18.0297 14.9459 17.6641 15.1875 17.6641H21.3125C21.5541 17.6641 21.75 18.0297 21.75 18.4807C21.75 18.9318 21.5541 19.2974 21.3125 19.2974H15.1875C14.9459 19.2974 14.75 18.9318 14.75 18.4807Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharges);
export default __webpack_public_path__ + "static/media/charges.7301ff47e8fc330daad6d436430fca00.svg";
export { ForwardRef as ReactComponent };